import { render } from "./registreChoice.vue?vue&type=template&id=5fc7da2e&scoped=true"
import script from "./registreChoice.vue?vue&type=script&lang=js"
export * from "./registreChoice.vue?vue&type=script&lang=js"

import "./registreChoice.vue?vue&type=style&index=0&id=5fc7da2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc7da2e"]])

export default __exports__